import { render, staticRenderFns } from "./DiagnosticAppointment.vue?vue&type=template&id=76d71250"
import script from "./DiagnosticAppointment.vue?vue&type=script&lang=js"
export * from "./DiagnosticAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports